import script from "./TheFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheFooter.vue?vue&type=script&lang=ts&setup=true"

import "./TheFooter.vue?vue&type=style&index=0&id=382f5ee0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382f5ee0"]])

export default __exports__